export default __webpack_public_path__ + "static/media/fireplace.73b80ad8.png";